import LinkedInIcon from '@material-ui/icons/LinkedIn';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import YouTubeIcon from '@material-ui/icons/YouTube';
import TwitterIcon from '@material-ui/icons/Twitter';
import style from './block.module.scss';

function Social({ customSettings }) {
    return (
        <ul className={style.social}>
            {customSettings.youtubeUrl && (
                <li>
                    <a href={customSettings.youtubeUrl} rel="noopener noreferrer" target="_blank">
                        <YouTubeIcon />
                    </a>
                </li>
            )}
            {customSettings.linkedinUrl && (
                <li>
                    <a href={customSettings.linkedinUrl} rel="noopener noreferrer" target="_blank">
                        <LinkedInIcon />
                    </a>
                </li>
            )}
            {customSettings.facebookUrl && (
                <li>
                    <a href={customSettings.facebookUrl} rel="noopener noreferrer" target="_blank">
                        <FacebookIcon />
                    </a>
                </li>
            )}
            {customSettings.instagramUrl && (
                <li>
                    <a href={customSettings.instagramUrl} rel="noopener noreferrer" target="_blank">
                        <InstagramIcon />
                    </a>
                </li>
            )}
            {customSettings.twitterUrl && (
                <li>
                    <a href={customSettings.twitterUrl} rel="noopener noreferrer" target="_blank">
                        <TwitterIcon />
                    </a>
                </li>
            )}
        </ul>
    );
}

export default Social;
